export enum BookButtonDataHooks {
  ACTION_BUTTON = 'booking-details-action-button',
  SPINNER = 'booking-details-spinner',
  CART_CHECKOUT_CTA = 'booking-details-cart-checkout-cta',
  CART_ADD_TO_CART_CTA = 'booking-details-cart-checkout-add-to-cart-cta',
}
